export default {
  NO_PERMISSION_TOOLTIP: "You don't have permission for this action",
  PRICING_TITLE: 'PRICING PLAN',
  STATISTICS_TITLE: 'Transactions statistic by apps',
  PRICING_PLAN_PER_ITEMS: 'Price per item',
  PRICING_MONTHLY_FEE: 'Monthly Fee',
  PRICING_MAX_VERIFICATION: 'Max verifications number',

  INVOICE_TITLE: 'Invoices',
  INVOICE_ACCOUNT: 'Account number',
  BANK_TRANSFER: 'Bank transfer',
  NEW_INVOICE: 'new',
  BILLING_STATISTICS: 'Client billing statistics',
  STATISTICS_COUNT: 'Count',

  PRICING_MONTHLY_TOTAL: 'Monthly Total',
  PRICING_EXTRA_FEE: 'Extra fee',
  PRICING_TEST_VERIFICATION: 'Test verifications number',

  REQUEST_SCALE_PLAN_TITLE: 'Request a custom Scale plan',
  REQUEST_SCALE_PLAN_DESCRIPTION:
    'Tell us about your expected verification volume and share any details that can help us prepare a tailored pricing proposal.',
  ESTIMATED_VOLUME: 'Estimated verification volume',
  ESTIMATED_VOLUME_PLACEHOLDER: 'e.g. 10,000 per month',
  ESTIMATED_VOLUME_HINT: 'An approximate number is enough',
  CONTACT_EMAIL: 'Contact email',
  CONTACT_EMAIL_PLACEHOLDER: 'name@company.com',
  CONTACT_EMAIL_HINT: "We'll contact you at this email",
  ADDITIONAL_DETAILS: 'Additional details',
  ADDITIONAL_DETAILS_PLACEHOLDER: 'Use case, regions, compliance needs',
  ADDITIONAL_DETAILS_HINT: 'Optional, but helps us prepare a more accurate offer',
  REQUEST_PRICING: 'Request pricing',
  VOLUME_REQUIRED: 'Please enter estimated volume',
  EMAIL_REQUIRED: 'Please enter contact email',
  EMAIL_INVALID: 'Please enter a valid email',
  REQUEST_SENT_TITLE: 'Request sent',
  REQUEST_SENT_DESCRIPTION:
    'Thanks for reaching out. Our sales team will review your request and contact you shortly with a custom pricing proposal.',
  REQUEST_SENT_EMAIL_NOTE: "We'll contact you at the email you provided.",
  CLOSE: 'Close',

  BILLING: 'Billing',
  MONTHLY: 'Monthly',
  ANNUALLY: 'Annually',
  ANNUAL_DISCOUNT: '10% off',
  PER_MONTH: 'per month',
  PER_YEAR: 'per year',
  FOR_MONTHS: 'for {{period}} months',
  FOR_YEARS: 'for {{period}} years',
  RENEWS_ON: 'Renews on {{date}}',
  FROM: 'from',
  CUSTOM: 'Custom',
  CONTINUE_WITH: 'Continue with {{plan}}',
  CURRENT_PLAN: 'Current plan',
  PREPARED_FOR_YOU: 'Prepared for you',
  DOWNGRADE: 'Downgrade',
  LETS_TALK: "Let's talk",
  SERVICES_DESCRIPTION: 'Service deduction (from prepaid balance)',
  SERVICES_SUBTITLE: 'Higher plans give you lower per-check costs.',
  CUSTOM_PRICE: 'custom',

  PLAN_STARTUP: 'Startup',
  PLAN_GROWTH: 'Growth',
  PLAN_SCALE: 'Scale',

  STARTUP_DESCRIPTION:
    'Perfect for starting a regulated business.<br/><br/>Includes everything you need to become compliant from day one.',
  GROWTH_DESCRIPTION:
    'Ideal for companies beginning to expand their customer base.<br/><br/>Ensure cost-effective compliance as your business grows.',
  SCALE_DESCRIPTION:
    'Best for high-volume clients.<br/><br/>Maximize your compliance efficiency with our premium package offering the most significant discounts.',

  SERVICE_ID_VERIFICATION: 'ID Verification',
  SERVICE_LIVENESS: 'Liveness & Facematch',
  SERVICE_UNIQUENESS: 'Unique Identity Check',
  SERVICE_AML: 'AML Screening',
  SERVICE_MONITORING: 'Ongoing monitoring (annual)',
  SERVICE_ADDRESS_VERIFICATION: 'Address Verification (No Document)',
  SERVICE_PROOF_OF_ADDRESS: 'Proof of Address (Document-Based)',
  SERVICE_WALLET: 'Wallet / Transaction screening',
  SERVICE_WALLET_MONITORING: 'Wallet Monitoring',
  SERVICE_EMAIL_OTP: 'Email verification (otp)',
  SERVICE_EMAIL_VALIDATION: 'Email Validation',
  SERVICE_PHONE_SMS: 'Phone verification (sms)',
  SERVICE_PHONE_CALL: 'Phone verification (call)',
  SERVICE_PHONE_VALIDATION: 'Phone Verification',
  SERVICE_PHONE_HRL: 'Phone HLR Lookup (Carrier Check)',
  SERVICE_QUESTIONNAIRE: 'Questionnaire',
  SERVICE_SUPPORT: 'Support',
  SERVICE_CONTRACT: 'Contract included',

  SERVICE_UNIQUENESS_TOOLTIP: 'Confirms a real, unique person within the users database.',
  SERVICE_MONITORING_TOOLTIP:
    'Continuously monitor for AML compliance, alerting you to any suspicious activities or changes in status.',
  SERVICE_ADDRESS_VERIFICATION_TOOLTIP: 'Validates a user’s address without requiring documents.',
  SERVICE_PROOF_OF_ADDRESS_TOOLTIP:
    'Verifies a user’s address using an official document like a utility bill or bank statement.',
  SERVICE_WALLET_TOOLTIP:
    'Securely monitor users’ cryptocurrency wallets and verify transaction details in real-time. It provides an easy way to track balances, transaction history, and confirmations, ensuring transparency and control over your digital assets.',
  SERVICE_WALLET_MONITORING_TOOLTIP:
    'Tracks wallet activity, charging 10 requests to start and one request per new transaction detected.',
  SERVICE_EMAIL_VALIDATION_TOOLTIP: 'Checks that the email is real, active, and not disposable.',
  SERVICE_PHONE_VALIDATION_TOOLTIP: 'Confirms the phone number is valid, reachable, and not temporary.',
  SERVICE_PHONE_HRL_TOOLTIP:
    'Checks with the mobile carrier to confirm the number is active and assigned to a subscriber.',

  BILLING_DETAILS_TITLE: 'Billing Details',
  BILLING_DETAILS_DESCRIPTION:
    "We need this information to issue invoices and comply with billing and tax regulations. You'll be redirected to the payment page in the next step.",
  COUNTRY_OF_REGISTRATION: 'Country of registration',
  SELECT_COUNTRY: 'Select country',
  VAT_NUMBER: 'VAT number',
  VAT_NUMBER_PLACEHOLDER: 'e.g. VAT ID, EIN, or company number',
  VAT_NUMBER_HINT: 'Your tax identification or company registration number',
  BILLING_EMAIL: 'Billing email',
  BILLING_EMAIL_PLACEHOLDER: 'name@company.com',
  BILLING_EMAIL_HINT: 'Invoices and billing updates will be sent to this email',
  ADDRESS_LINE1: 'Address line 1',
  ADDRESS_LINE1_PLACEHOLDER: 'Street address',
  ADDRESS_LINE2: 'Address line 2',
  ADDRESS_LINE2_PLACEHOLDER: 'Apt, suite, unit, etc.',
  CITY: 'City',
  CITY_PLACEHOLDER: 'City',
  STATE: 'State / Region',
  STATE_PLACEHOLDER: 'State or region',
  POSTAL_CODE: 'Postal code',
  POSTAL_CODE_PLACEHOLDER: 'Postal code',
  PHONE_NUMBER: 'Phone number',
  PHONE_NUMBER_PLACEHOLDER: '+1234567890',
  SIGNED_AGREEMENT: 'I want to proceed with a signed agreement',
  SIGNED_AGREEMENT_TOOLTIP:
    'Our team will review your request and contact you to arrange contract-based billing.',
  BACK: 'Back',
  CONTINUE_TO_PAYMENT: 'Continue to payment',
  SAVE: 'Save',
  COUNTRY_REQUIRED: 'Please select a country',
  VAT_NUMBER_REQUIRED: 'Please enter VAT number',
  VAT_NUMBER_INVALID: 'Please enter a valid VAT number',
  BILLING_EMAIL_REQUIRED: 'Please enter billing email',
  BILLING_EMAIL_INVALID: 'Please enter a valid email',
  ADDRESS_LINE1_REQUIRED: 'Please enter address',
  CITY_REQUIRED: 'Please enter city',
  POSTAL_CODE_REQUIRED: 'Please enter postal code',
  PHONE_NUMBER_REQUIRED: 'Please enter phone number',
  PHONE_NUMBER_INVALID: 'Please enter a valid phone number',
  FIELD_TOO_LONG: 'This value is too long',
  SOMETHING_WENT_WRONG: 'Something went wrong. Please try again.',

  CURRENT_PLAN_LABEL: 'Current plan',
  UPGRADE: 'Upgrade',
  UPGRADE_PLAN: 'Upgrade plan',
  PAY_NOW: 'Pay now',
  CANCEL_SUBSCRIPTION: 'Cancel plan',
  CHANGE_PAYMENT_INFORMATION: 'Change payment information',
  NEED_TO_PAY: 'NEED TO PAY',
  TRIAL_PERIOD: 'Trial period',
  TRIAL_SUFFIX: 'Trial',
  DAYS_REMAINING: '{{days}} days remaining',
  ENDS_ON: 'Ends on {{date}}',
  TRIAL_DESCRIPTION: '{{days}}-day trial with {{balance}} credits',
  TRIAL_FEATURE_CREDITS: 'Verification credits',
  TRIAL_FEATURE_ACCESS: 'Full platform access during trial',
  TRIAL_FEATURE_TOPUP: 'Ability to top up credits anytime',
  TRIAL_WARNING: 'After the trial ends, access will be paused until a paid plan is activated.',
  VIEW_PRICING_PLANS: 'View pricing plans',
  TRIAL_ENDED_TITLE: 'Your trial has ended',
  TRIAL_ENDED_DESCRIPTION:
    'Choose a plan to continue using the platform and access all verification services.',
  BANNER_TRIAL_ACTIVE_TITLE: 'Trial plan active · {{days}} days remaining.',
  BANNER_TRIAL_ACTIVE_TEXT:
    'Upgrade to enable Live mode and ensure uninterrupted access after the trial ends.',
  BANNER_TRIAL_ENDED_TITLE: 'Your trial has ended.',
  BANNER_TRIAL_ENDED_TEXT:
    'Choose a plan to continue using the platform and access all verification services.',
  BANNER_GO_TO_BILLING: 'Go to billing',
  FEATURE_PREMIUM: 'Better pricing',
  FEATURE_SUPPORT: 'Lower usage costs',
  FEATURE_SECURITY: 'Same features, better value',
  FEATURE_CUSTOM_LIMITS: 'All custom limits',
  FEATURE_FULL_ACCESS: 'Full platform access',
  FEATURE_USAGE_BASED: 'Usage-based billing',
  FEATURE_VOLUME_DISCOUNTS: 'Volume discounts as you scale',
  FEATURE_LOWER_COSTS: 'Upgrade for lower per-unit costs',

  BALANCE: 'Balance',
  TRIAL_BALANCE: 'Trial balance',
  MINIMUM_BALANCE: 'Minimum balance:',
  REPLENISH: 'Refill',
  PAYMENT_METHOD: 'Payment method',
  CARD_EXPIRES: 'Expires {{date}}',
  CARD_ACTIVE: 'Active',
  UPDATE: 'Update',
  REFILL_BALANCE: 'Refill Balance',
  REFILL_BALANCE_TITLE: 'Refill Balance',
  REFILL_BALANCE_DESCRIPTION: 'Enter the amount you want to add to your balance.',
  REFILL_AMOUNT_PLACEHOLDER: 'Enter amount',
  REFILL_MIN_AMOUNT: 'Minimum deposit is {{amount}}',
  REFILL_MAX_AMOUNT: 'Maximum deposit is {{amount}}',
  REFILL_CONFIRM: 'Proceed to payment',
  CANCEL: 'Cancel',
  PAID: 'Paid',
  INVOICE_PAID: 'Paid',
  INVOICE_UNPAID: 'Unpaid',
  INVOICE_EXPIRED: 'Expired',
  INVOICE_CANCELED: 'Canceled',

  TX_NAME: 'Name',
  TX_AMOUNT: 'Amount',
  TX_STATUS: 'Status',
  TX_TYPE: 'Type',
  TX_DATE_TIME: 'Date & Time',
  TX_ACTIONS: 'Actions',
  TX_TYPE_INVOICE: 'Invoice',
  TX_TYPE_REPLENISH: 'Refill',
  TX_DOWNLOAD: 'Download',
  TX_DOWNLOAD_FORMAT: 'PDF',
  TX_ROWS_PER_PAGE: 'Rows per page:',
  INVOICES_RECEIPTS: 'Invoices & Receipts',

  OUT_OF_CREDITS_TITLE: "Oops! You've run out of credits.",
  OUT_OF_CREDITS_DESCRIPTION:
    'To continue enjoying uninterrupted service and access to all your features, please refill your balance now.',

  USAGE: 'Usage',
  TIMES: '{{count}} times',
  USAGE_MODE_LIVE: 'Live',
  USAGE_MODE_TEST: 'Test',
  USAGE_EMPTY: 'No usage for the selected period',
  USAGE_TOTAL: 'Total',
  USAGE_ERROR_BUSY: 'Usage is busy. Try again in a moment.',
  USAGE_ERROR_INVALID: 'The request was rejected: {{message}}',
  USAGE_ERROR_GENERIC: 'Could not load usage.',
  USAGE_ERROR_RANGE: 'This date range is not supported. Choose a range of at most {{max}} days.',
  USAGE_RETRY: 'Retry',

  PERIOD_STATEMENTS_TITLE: 'Billing period summaries',
  PERIOD_STATEMENTS_DESCRIPTION:
    'Usage, minimum commitment and charges to your balance for completed billing periods.',
  PERIOD_STATEMENTS_EMPTY: 'No completed billing periods yet.',
  PERIOD_STATEMENTS_ERROR: 'Could not load billing period summaries: {{message}}',
  PERIOD_STATEMENTS_LOADING: 'Loading billing period summaries',
  PERIOD_STATEMENTS_PAGINATION: '{{from}}–{{to}} of {{count}}',
  PERIOD_STATEMENTS_PAGINATION_FIRST: 'Go to first billing period page',
  PERIOD_STATEMENTS_PAGINATION_PREVIOUS: 'Go to previous billing period page',
  PERIOD_STATEMENTS_PAGINATION_NEXT: 'Go to next billing period page',
  PERIOD_STATEMENTS_PAGINATION_LAST: 'Go to last billing period page',
  PERIOD_STATEMENT_PERIOD: 'Billing period',
  PERIOD_STATEMENT_USAGE: 'Usage',
  PERIOD_STATEMENT_MINIMUM_COMMITMENT: 'Minimum commitment',
  PERIOD_STATEMENT_BALANCE_ADJUSTMENT: 'Charged to balance',
  PERIOD_STATEMENT_RESULT: 'Result',
  PERIOD_STATEMENT_RESULT_MINIMUM_MET: 'Minimum met',
  PERIOD_STATEMENT_RESULT_DIFFERENCE_DEBITED: 'Unused minimum charged',
  PERIOD_STATEMENT_RESULT_PARTIALLY_DEBITED: 'Partially charged',
  PERIOD_STATEMENT_RESULT_NOT_DEBITED: 'Not charged',
  PERIOD_STATEMENT_EXPAND: 'Expand billing period',
  PERIOD_STATEMENT_COLLAPSE: 'Collapse billing period',
  PERIOD_STATEMENT_USAGE_BREAKDOWN: 'Usage breakdown',
  PERIOD_STATEMENT_SERVICE: 'Service',
  PERIOD_STATEMENT_COUNTRY: 'Country',
  PERIOD_STATEMENT_REQUESTS: 'Requests',
  PERIOD_STATEMENT_AMOUNT: 'Amount',
  PERIOD_STATEMENT_NO_USAGE: 'No charges in this billing period.',
  PERIOD_STATEMENT_UNUSED_MINIMUM: 'Unused part of minimum',
  PERIOD_STATEMENT_DEBITED: 'Charged to balance',
  PERIOD_STATEMENT_DEBITED_AT: 'Charged on',
  PERIOD_STATEMENT_HINT_PERIOD: 'The days of the billing period, shown in UTC.',
  PERIOD_STATEMENT_HINT_USAGE: 'Total charged for your verifications and checks during the period.',
  PERIOD_STATEMENT_HINT_MINIMUM_COMMITMENT: 'The least amount your plan requires you to spend in one period.',
  PERIOD_STATEMENT_HINT_BALANCE_ADJUSTMENT:
    'Amount taken from your balance when usage was below the minimum.',
  PERIOD_STATEMENT_HINT_RESULT: 'Whether the minimum was reached and what was charged.',
  PERIOD_STATEMENT_HINT_UNUSED_MINIMUM: 'Minimum commitment minus usage.',
  PERIOD_STATEMENT_HINT_MINIMUM_MET: 'Usage reached the minimum. Nothing extra was charged.',
  PERIOD_STATEMENT_HINT_DIFFERENCE_DEBITED:
    'Your usage was below the minimum commitment. The difference was charged from your balance to reach the minimum.',
  PERIOD_STATEMENT_HINT_PARTIALLY_DEBITED:
    'Usage was below the minimum, but your balance covered only part of the unused amount.',
  PERIOD_STATEMENT_HINT_NOT_DEBITED:
    'Usage was below the minimum, but nothing could be charged to your balance.',

  USAGE_SERVICE_TRANSACTION_RISK_SCORE: 'Wallet / Transaction screening',
  USAGE_SERVICE_PROOF_OF_ADDRESS_RECOGNITION: 'Proof of Address (Document-Based)',
  USAGE_SERVICE_PROOF_OF_ADDRESS_MATCH: 'Proof of Address Match',
  USAGE_SERVICE_BARCODE_CAPTURE: 'Barcode capture',
  USAGE_SERVICE_CREDIT_CARD_CAPTURE: 'Credit card capture',
  USAGE_SERVICE_SPECIFIC_DOCUMENT_CAPTURE: 'Specific document capture',
  USAGE_SERVICE_SELFIE_CAPTURE: 'Selfie capture',
  USAGE_SERVICE_FACE_CAPTURE: 'Face capture',
  USAGE_SERVICE_SIGNATURE: 'Signature verification',
  USAGE_SERVICE_OTP_VERIFICATION: 'OTP Verification',
  USAGE_SERVICE_UTILITY_BILL: 'Utility bill verification',
  USAGE_SERVICE_DIIA: 'Diia',
  USAGE_SERVICE_FACE_MATCH: 'Facematch',
  USAGE_SERVICE_FACE_LIVENESS: 'Liveness',
  USAGE_SERVICE_DOCUMENT_CAPTURE: 'ID Verification',
  USAGE_SERVICE_CLEAN_DOCUMENT_CAPTURE: 'Document Capture',
  USAGE_SERVICE_RFID_DOCUMENT_CAPTURE: 'RFID ID Verification',
  USAGE_SERVICE_PASSIVE_FACE_MATCH: 'Facematch',
  USAGE_SERVICE_PASSIVE_LIVENESS: 'Liveness',
  USAGE_SERVICE_AML: 'AML Screening',
  USAGE_SERVICE_QUESTIONNAIRE: 'Questionnaire',
  USAGE_SERVICE_AML_MONITORING: 'Ongoing monitoring (annual)',
  USAGE_SERVICE_AI_ASSISTANT_DOCUMENT: 'AI Document assistant',
  USAGE_SERVICE_EMAIL_OTP_VERIFICATION: 'Email verification (otp)',
  USAGE_SERVICE_PHONE_HLR_VERIFICATION: 'Phone HLR Lookup (Carrier Check)',
  USAGE_SERVICE_PHONE_SMS_OTP_VERIFICATION: 'Phone verification (sms)',
  USAGE_SERVICE_PHONE_VOICE_OTP_VERIFICATION: 'Phone verification (call)',
  USAGE_SERVICE_EMAIL_VERIFICATION: 'Email Validation',
  USAGE_SERVICE_PHONE_VERIFICATION: 'Phone Verification',
  USAGE_SERVICE_ADDRESS_RISK_SCORE: 'Wallet / Transaction screening',
  USAGE_SERVICE_TRANSACTION_MONITORING: 'Wallet Monitoring',
  USAGE_SERVICE_PROOF_OF_ADDRESS: 'Address Verification (No Document)',
  USAGE_SERVICE_FACE_MATCH_UNIQUENESS: 'Unique Identity Check',

  SUBSCRIPTION_CANCELED: 'Subscription canceled',
  SUBSCRIPTION_ENDED: 'Subscription ended',
  SUBSCRIPTION_PAUSED: 'Subscription paused',
  PAYMENT_INCOMPLETE: 'Payment incomplete',
  PAYMENT_EXPIRED: 'Payment expired',
  REACTIVATE: 'Reactivate',
  RESUME: 'Resume',
  COMPLETE_PAYMENT: 'Complete payment',
  CHOOSE_PLAN: 'Choose plan',
  DOWNGRADE_SUCCESS: 'Your plan has been downgraded successfully',

  NEW_PLAN_LABEL: 'New plan',
  CHANGES: 'Changes',
  UPGRADE_CREDITS_NOTE: 'Your unused credits will be transferred to the new plan.',
  UPGRADE_BENEFITS_NOTE: 'New benefits will be available immediately.',
  UPGRADE_UNDERSTAND_LABEL: 'I understand how this change may affect my billing and usage',
  CONFIRM_UPGRADE: 'Confirm upgrade',

  DOWNGRADE_PLAN: 'Downgrade plan',
  DOWNGRADE_FEATURE_LIMITS: 'Lower usage limits',
  DOWNGRADE_FEATURE_ACCESS: 'Reduced feature access',
  DOWNGRADE_BILLING_NOTE: 'The downgrade will take effect at the next billing period.',
  DOWNGRADE_ACTIVE_NOTE: 'Your current plan will remain active until then.',
  DOWNGRADE_UNDERSTAND_LABEL: 'I understand that my plan limits and features may change',
  CONFIRM_DOWNGRADE: 'Confirm downgrade',

  CANCEL_SUBSCRIPTION_DESC_1:
    'Your subscription will remain active until the end of the current billing period.',
  CANCEL_SUBSCRIPTION_DESC_2: 'After that, access to paid features will be limited.',
  CANCEL_UNDERSTAND_LABEL: 'I understand that I will lose access to paid features after cancellation',
  KEEP_PLAN: 'Keep plan',
  CANCEL_SUBSCRIPTION_SUCCESS: 'Your subscription will be canceled on {{date}}',

  RENEW_PLAN: 'Renew plan',
  RENEW_SUBSCRIPTION_TITLE: 'Renew Subscription?',
  RENEW_SUBSCRIPTION_DESC_1:
    'Your subscription has been canceled and will end at the end of your current billing period.',
  RENEW_SUBSCRIPTION_DESC_2:
    'Would you like to renew your subscription and continue enjoying uninterrupted access?',
  RENEW_SUBSCRIPTION_CONFIRM: 'Renew Subscription',
  KEEP_CANCELLATION: 'Keep Cancellation',
  RENEW_SUBSCRIPTION_SUCCESS: 'Your subscription has been renewed',

  SCHEDULED_CANCEL: 'Your plan will be cancelled on {{date}}',
  SCHEDULED_UPGRADE: 'Your plan will be upgraded to {{plan}} on {{date}}',
  SCHEDULED_DOWNGRADE: 'Your plan will be downgraded to {{plan}} on {{date}}',

  STATUS_TITLE_CANCELED: 'Subscription canceled',
  STATUS_TITLE_ENDED: 'Subscription ended',
  STATUS_TITLE_PAST_DUE: 'Payment overdue',
  STATUS_TITLE_PAUSED: 'Subscription paused',
  STATUS_SUBTITLE_INCOMPLETE: 'Subscription not active yet',
  STATUS_SUBTITLE_INCOMPLETE_EXPIRED: 'Subscription not activated',

  STATUS_DESC_CANCELED: 'Your subscription has been canceled. Access to features is no longer available.',
  STATUS_DESC_ENDED: 'Your subscription period has ended. Renew to restore access.',
  STATUS_DESC_PAST_DUE: "We couldn't process your payment. Please retry shortly.",
  STATUS_DESC_PAUSED: 'Your subscription is temporarily paused. Billing is on hold.',
  STATUS_DESC_INCOMPLETE: 'Complete your payment to activate your subscription.',
  STATUS_DESC_INCOMPLETE_EXPIRED: 'Your previous setup expired. Start again to activate a subscription.',

  SIDEBAR_WARNING_CANCELED: 'Your subscription is no longer active.',
  SIDEBAR_WARNING_ENDED: 'Add credits or renew your plan to continue using the service.',
  SIDEBAR_WARNING_PAST_DUE: 'Payment failed. Please check your payment details to avoid interruptions.',
  SIDEBAR_WARNING_UNPAID:
    "You've run out of credits. To continue using the service, please refill your balance.",
  SIDEBAR_WARNING_PAUSED: 'No charges are being processed at the moment.',

  PAYMENT_SUCCESS_TITLE: 'All set!',
  PAYMENT_SUCCESS_DESCRIPTION: 'Everything has been completed successfully.',
  PAYMENT_PENDING_TITLE: 'Payment in progress',
  PAYMENT_PENDING_DESCRIPTION:
    'Your payment is being reviewed and will be confirmed shortly. You can safely close this window.',
  PAYMENT_FAILED_TITLE: 'Something went wrong',
  PAYMENT_FAILED_DESCRIPTION: "We couldn't complete your request. Please try again.",
  TRY_AGAIN: 'Try again',
};
